<template>
  <v-form v-model="valid" ref="form" style="height: 100vh; background-color: #111111 !important;">
    <v-container class="login-container" fluid>
      <v-row style="height: 100% !important;">
        <v-col class="pa-12 d-flex align-center" cols="6">
          <v-container class="ml-12" fluid>
            <v-row>
              <v-col cols="10">
                <h1 class="white-content" v-html="$t('joinSmartTraders')"></h1>
                <h3 class="mb-3">{{ $t('createSwisetAccount') }}</h3>
              </v-col>
              <v-col v-if="step === 1" cols="7">
                  <v-text-field v-model="firstName" :label="$t('form.firstName.label')" :rules="firstNameRule" dark outlined/>
                  <v-text-field v-model="lastName" :label="$t('form.lastName.label')" :rules="lastNameRule" dark outlined/>
                  <v-text-field v-model="email" :label="$t('form.email.label')" :rules="emailRule" type="email" dark outlined/>
              </v-col>
              <v-col v-else-if="step === 2" cols="7">
                  <v-text-field v-model="username" :label="$t('form.username.label')" :rules="usernameRule" dark outlined/>
                  <v-text-field v-model="password" :label="$t('form.password.label1')"
                                :rules="passwordRule" :type="showPassword ? 'text' : 'password'" dark outlined>
                    <v-icon slot="append" class="icon" color="white" @click="showPassword = !showPassword">
                      {{ (showPassword) ? 'fa-eye' : 'fa-eye-slash' }}
                    </v-icon>
                  </v-text-field>
                  <v-text-field v-if="password !== ''" v-model="confirmPassword" :label="$t('form.password.label2')"
                                :rules="confirmPasswordRule" :type="showConfirmPassword ? 'text' : 'password'" dark outlined>
                    <v-icon slot="append" class="icon" color="white" @click="showConfirmPassword = !showConfirmPassword">
                      {{ (showConfirmPassword) ? 'fa-eye' : 'fa-eye-slash' }}
                    </v-icon>
                  </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div v-if="step === 2" class="d-flex align-center justify-start">
                  <v-btn class="green-button mr-3" dark x-large @click="goBack">{{ $t('backBtn') }}</v-btn>
                  <v-btn :disabled="!valid" class="green-button" :loading="loadingRegister" dark x-large
                         @click="createCollapsedAccount">{{ $t('createBtn') }}</v-btn>
                </div>
                <v-btn v-else :disabled="!valid" class="green-button" :loading="loadingRegister" dark x-large
                       @click="validateEmail">{{ $t('nextBtn') }}</v-btn>
                <p class="light-grey-content mt-12" v-html="$t('alreadyHaveSwisetAccount')"/>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col class="signup-image" cols="6">
          <!--transition name="fade" style="padding: 0; margin: 0;">
            <v-img :src="bigImageSrc" :key="bigImageSrc" data-toggle="tooltip" data-placement="bottom" title="goTop" alt="" contain max-height="100vh"/>
          </transition!-->
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog for existing email !-->
    <v-dialog v-model="existingUsernameOrEmail" max-width="500">
      <v-card outlined>
        <v-card-title class="py-5 headline grey lighten-2 justify-center">
          <h3 v-if="existingEmail">{{ $t('existsInSwiset', {data: email}) }}</h3>
          <h3 v-if="existingUsername">{{ $t('existsInSwiset', {data: username}) }}</h3>
        </v-card-title>
        <v-card-text class="my-5 text-center justify-center">
          <p v-if="existingEmail" v-html="$t('resetPassword')"></p>
          <p v-if="existingUsername">{{ $t('anotherUsername') }}</p>
          <v-btn @click="existingUsernameOrEmail = false"> Ok</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Repository from '../../../repositories/auth';

export default {
  props: {
    referred: String
  },
  name: "Welcome",
  data() {
    return {
      bigImageSrc: 'https://swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png',
      images: [
        { src: 'https://swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png', },
        { src: 'https://swiset.com/wp-content/uploads/2020/05/Automatic-Trading-Journal-in-Swiset.png', },
      ],

      step: 1,
      existingUsernameOrEmail: false,
      existingUsername: false,
      existingEmail: false,
      valid: false,
      validSecond: false,
      loadingRegister: false,
      showPassword: false,
      showConfirmPassword: false,

      highlight: '',
      landingKey: '',
      discount: 0,

      //data
      firstName: '',
      lastName: '',
      email: '',
      username: '',
      password: '',
      confirmPassword: '',
      firstNameRule: [
        p => !!p || this.$t('form.firstName.rule'),
      ],
      lastNameRule: [
        p => !!p || this.$t('form.lastName.rule'),
      ],
      emailRule: [
        e => !!e || this.$t('form.email.rule'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || this.$t('form.email.rule2'),
      ],
      usernameRule: [
        u => !!u || this.$t('form.username.rule1'),
        u => (u || '').length < 35 || this.$t('form.username.rule2'),
        u => !u.includes('@') || this.$t('form.username.rule3'),
        u => !u.includes('&') || this.$t('form.username.rule4'),
        u => (u.split(' ').length <= 1) || this.$t('form.username.rule5'),
      ],
      passwordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => (p || '').length < 60 || this.$t('form.password.rule2'),
        p => (p || '').length > 6 || this.$t('form.password.rule3'),
      ],
      confirmPasswordRule: [
        p => !!p || this.$t('form.password.rule1'),
        p => p === this.password || this.$t('form.password.rule4'),
      ],
    };
  },
  computed: {
    _seconds: () => 1000,
  },
  created() {
    this.getQueryParams();
    this.validateAuthenticated();
  },
  mounted() {
    this.setTimerImage();
  },
  methods: {
    goNext() {
      this.step++;
      this.$refs.form.resetValidation();
    },
    goBack() {
      this.step--;
    },
    setTimerImage() {
      let endTime = new Date();
      endTime.setSeconds(endTime.getSeconds() + 8);
      const timer = setInterval(() => {
        let now = new Date();
        let distance = endTime.getTime() - now.getTime();
        if(distance < 1) {
          this.setImage();
          clearInterval(timer);
          this.setTimerImage();
        }
      }, 1000);
    },
    setImage() {
      let currentImageIndex = this.images.findIndex((img) => img.src === this.bigImageSrc);
      currentImageIndex++;
      this.bigImageSrc = this.images[(currentImageIndex === this.images.length)? 0 : currentImageIndex].src;
    },
    validateAuthenticated() {
      if (this.$store.state.token !== '') {
        if (this.referred != null)
          this.$router.push({ name: 'profile', params: { referred: this.referred } });
        else if (!this.$store.state.user.isPro) {
          if (this.highlight !== '')
            this.$router.push({ name: 'subscription-plans', params: { highlight: this.highlight }});
          else
            this.$router.push('/subscription-plans');
        } else
          this.$router.push('/dashboard');
      }
    },
    getQueryParams() {
      if (this.$route.query.landingKey !== undefined)
        this.landingKey = this.$route.query.landingKey;
      if (this.$route.query.highlight !== undefined)
        this.highlight = this.$route.query.highlight;
      if (this.$route.query.discount !== undefined)
        this.discount = this.$route.query.discount;
    },
    validateEmail() {
      if (this.valid) {
        this.loadingRegister = true;
        Repository.existingUsernameOrEmail(this.username, this.email).then((response) => {
          if (response.status < 400) {
            this.loadingRegister = false;
            let data = response.data;
            if (data === -1) {
              this.goNext();
              /*this.$router.push({
                name: 'basic-data',
                params: {
                  firstName: this.firstName,
                  lastName: this.lastName,
                  email: this.email,
                  username: this.username,
                  password: this.password,
                  referredFrom: this.referred,
                  plan: this.highlight,
                  landingKey: this.landingKey,
                  discount: this.discount,
                }
              });*/
            } else
              this.dialogExistingEmailOrUsername(data);
          }
        });
      } else
        alert(this.$t('alertMessage'));
    },
    createCollapsedAccount() {
      this.loadingRegister = true;
      Repository.existingUsernameOrEmail(this.username, this.email).then((response) => {
        if (response.status < 400) {
          let data = response.data;
          if (data === -1) {
            let user = {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              username: this.username,
              password: this.password,
              phoneNumber: 'NOT REGISTERED',
              referredFrom: this.referred,
              langKey: this.$i18n.locale,
              channel: 'OTHER',
              withoutAuth: true
            };

            Repository.registerCollapsedUser(user).then((secondResponse) => {
              if (secondResponse.status < 400) {
                window.sendinblue.identify(this.email, {
                  'NOMBRE': this.firstName,
                  'SURNAME' : this.lastName,
                  'USERNAME': this.username,
                  'PHONE': 'NOT REGISTERED',
                  'COUNTRY': 'NOT REGISTERED',
                  'PRO_ON' : '0',
                  'LANG' : this.$i18n.locale,
                  'CHANNEL' : 'OTHER',
                  'USAGE_STATE': 'PRE_REGISTERED',
                  'COMMERCIAL_STATE': 'NEVER_PRO',
                });
                window.fbq('track', 'SubmitApplication');
                window.fbq('trackCustom', 'VirtualPageView',
                    { url: (this.landingKey !== '')? `/pre-registration-by-desktop-${this.landingKey}` : '/pre-registration-by-desktop' });

                /*this.$router.push({
                name: 'subscription-plans-collapsed',
                params: {
                  userId: Number.parseInt(secondResponse.data.id),
                  highlight: this.highlight,
                  discount: Number.parseInt(this.discount)
                }});*/
                this.loadingRegister = false;
                this.$router.push({ name: 'confirmed-email', params: { email: this.email, password: this.password } });
              }
            });
          }
          else
            this.dialogExistingEmailOrUsername(data);
        }
      });
    },
    dialogExistingEmailOrUsername(data) {
      if (data === 1) {
        this.existingEmail = true;
        this.existingUsername = false;
      } else {
        this.existingEmail = false;
        this.existingUsername = true;
      }
      this.existingUsernameOrEmail = true;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/global.scss";

.white-content {
  color: $white-color;
}

.light-grey-content {
  color: $light-gray-color;
}

.v-input__icon--append .v-icon {
  color: #929292 !important;
  border: none !important;
}

.v-input__icon--append .v-icon:hover {
  color: #929292;
  background-color: rgba(85, 85, 85, 0);
  border: none;
}

.login-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.signup-image {
  padding: 0;
  background-color: #111111;
  background-image: url("https://swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}
</style>


<i18n>
{
  "en": {
    "joinSmartTraders": "Join thousands of <span style='color: #00F784; font: 32px Product Sans; font-weight: bold;'>smart traders</span>",
    "createSwisetAccount": "Create a Swiset account in few seconds.",
    "createAPassword": "Create a password",
    "confirmPassword": "Confirm password",
    "alreadyHaveSwisetAccount": "If you already have a Swiset account, <a href='https://app.swiset.com/'>click here</a> to login.",
    "existsInSwiset": "{data} already exists in Swiset",
    "nextBtn": "Next »",
    "backBtn": "« Back",
    "createBtn": "Create Account",
    "resetPassword": "<a href='https://app.swiset.com/reset-password'>Reset your password here</a> if you do not remember it, or create an account with another email.",
    "anotherUsername": "Please choose another username for your Swiset account.",
    "alertMessage": "There are one or more mandatory fields that are not filled.",
    "form": {
      "firstName": {
        "label": "First Name",
        "rule": "First Name is required"
      },
      "lastName": {
        "label": "Last Name",
        "rule": "Last Name is required"
      },
      "email": {
        "label": "Email",
        "rule": "Email is required",
        "rule2": "Invalid email"
      },
      "username": {
        "label": "Username",
        "rule1": "Username is required",
        "rule2": "Username should have less than 35 characters.",
        "rule3": "Not '@' allowed",
        "rule4": "Not & allowed",
        "rule5": "Not spaces allowed"
      },
      "password": {
        "label1": "Password",
        "label2": "Confirm Password",
        "rule1": "Password is required",
        "rule2": "Password should have less than 60 characters.",
        "rule3": "Password should have at least 7 characters.",
        "rule4": "Password don't match"
      }
    }
  },
  "es": {
    "joinSmartTraders": "Únete a miles de <span style='color: #00F784; font: 32px Product Sans; font-weight: bold;'>traders inteligentes</span>",
    "createSwisetAccount": "Crea una cuenta en Swiset en pocos segundos.",
    "createAPassword": "Crear una contraseña",
    "confirmPassword": "Confirmar contraseña",
    "alreadyHaveSwisetAccount": "Si ya tienes una cuenta en Swiset, dale <a href='https://app.swiset.com/'>click aquí</a> para ingresar.",
    "existsInSwiset": "{data} ya existe en Swiset",
    "nextBtn": "Siguiente »",
    "backBtn": "« Atrás",
    "createBtn": "Crear Cuenta",
    "resetPassword": "<a href='https://app.swiset.com/reset-password'>Vuelve a crear tu contraseña aquí</a> si no la recuerdas, o crea una nueva cuenta con otro email.",
    "anotherUsername": "Por favor usa otro nombre de usuario para tu cuenta de Swiset.",
    "alertMessage": "Hay uno o más campos sin completar.",
    "form": {
      "firstName": {
        "label": "Nombres",
        "rule": "El nombre es obligatorio"
      },
      "lastName": {
        "label": "Apellidos",
        "rule": "El apellido es obligatorio"
      },
      "email": {
        "label": "Email",
        "rule": "El email es obligatorio",
        "rule2": "Email inválido"
      },
      "username": {
        "label": "Nombre de usuario",
        "rule1": "El nombre de usuario es obligatorio",
        "rule2": "El nombre de usuario debe de tener menos de 35 caracteres.",
        "rule3": "El '@' no esta permitido",
        "rule4": "El '&' no esta permitido",
        "rule5": "El nombre de usuario no debe de tener espacios"
      },
      "password": {
        "label1": "Contraseña",
        "label2": "Confirmar contraseña",
        "rule1": "La contraseña es obligatoria",
        "rule2": "La contraseña debe de tener menos de 60 caracteres.",
        "rule3": "La contraseña debe de tener al menos 7 caracteres.",
        "rule4": "Las contraseñas no son iguales"
      }
    }
  }
}
</i18n>
